import { Divider, DividerProps } from "@nextui-org/divider";

const ZDivider = (props: DividerProps) => {
  return <Divider {...props} />;
};

export { ZDivider };
